import boxShadows from "assets/theme/box-shadow.js";
import themeColors from "assets/theme/colors.js";

const componentStyles = (theme) => ({
  flexMdRow: {
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row!important",
    },
  },
  iconInfo: {
    padding: "12px",
    textAlign: "center",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "1.25rem",
    height: "1.25rem",
    boxShadow: boxShadows.boxShadow,
    color: themeColors.white.main,
    borderRadius: "50%",
    background:
      "linear-gradient(87deg," +
      themeColors.info.main +
      ",#1171ef)!important",
  },
  mutedAnchor: {
    color: themeColors.gray[400],
    textDecoration: "none",
    backgroundColor: "initial",
    "&:hover": {
      color: themeColors.gray[500],
    },
  },
  cardRoot: {
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  cardContentRoot: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "6rem",
      paddingRight: "6rem",
    },
  },
  cardActionsRoot: {
    justifyContent: "center",
  },
  display2: {
    fontSize: "2.75rem",
    fontWeight: 600,
    lineHeight: 1.5,
  },
  titleInfo: {
    letterSpacing: ".0625rem",
    textTransform: "uppercase",
    color: themeColors.info.main,
    paddingTop: "1rem",
    paddingBottom: "1rem",
    marginBottom: "0",
  },
  cardRootGradientSuccess: {
    background:
      "linear-gradient(87deg," +
      themeColors.success.main +
      ",#2dcecc)!important",
    boxShadow: boxShadows.boxShadowLg,
    [theme.breakpoints.up("md")]: {
      zIndex: 1,
      transform: "scale(1.1)",
    },
  },
  bgInherit: {
    background: "inherit",
  },
  titleWhite: {
    letterSpacing: ".0625rem",
    textTransform: "uppercase",
    color: themeColors.white.main,
    paddingTop: "1rem",
    paddingBottom: "1rem",
    marginBottom: "0",
  },
  whiteAnchor: {
    color: themeColors.white.main,
    textDecoration: "none",
    backgroundColor: "initial",
    "&:hover": {
      color: themeColors.gray[100],
    },
  },
  iconWhite: {
    padding: "12px",
    textAlign: "center",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "1.25rem",
    height: "1.25rem",
    boxShadow: boxShadows.boxShadow,
    color: themeColors.gray[600],
    borderRadius: "50%",
    background: themeColors.white.main,
  },
  display1: {
    fontSize: "3.3rem",
    fontWeight: 600,
    lineHeight: 1.5,
  },
  buttonRootWhite: {
    color: themeColors.dark.main,
    backgroundColor: themeColors.white.main,
    borderColor: themeColors.white.main,
    marginRight: "1rem",
    "&:hover": {
      backgroundColor: themeColors.white.main,
      borderColor: themeColors.white.main,
      color: themeColors.dark.dark,
    },
  },
  justifyContentLgCenter: {
    [theme.breakpoints.up("md")]: {
      justifyContent: "center",
    },
  },
  avatarRoot: {
    backgroundColor: themeColors.bsColors.MainBlue,
  },
  tableCellHead: {
    borderTopColor: themeColors.dark.tableBorder,
    color: themeColors.gray[400],
  },
  tableCellBody: {
    borderBottomColor: themeColors.dark.tableBorder,
    color: themeColors.background.default,
  },
  tableRowBody: {
    "&:last-child $tableCellBody": {
      border: 0,
    },
  },
  header: {
    background: "linear-gradient(180.04deg, #FFFFFF 15.84%, #EEf4FA 240.04%)",
  },
  pricingBackground: {
    backgroundImage: "url(" + require("assets/img/theme/Dividends-stock-photo.jpg").default + ")",
    //backgroundSize:"1280px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center right",
    transform: "scaleX(-1)",
  },
  flipBox: {
    transform: "scaleX(-1)",
  },
  whiteBackground: {
    backgroundColor: "#ffffff",
  },
  flexColumnFlexXlRow: {
    flexDirection: "column!important",
    [theme.breakpoints.up("lg")]: {
      flexDirection: "row!important",
    },
  },
  typographyH1: {
    color: themeColors.bsColors.MainBlue,
    fontWeight: "700!important",
    marginBottom: "0!important",
    fontSize: "2.75rem",
    textAlign: "left",
    lineHeight: 1.5,
  },
  typographyH2: {
    color: themeColors.bsColors.MainBlue,
    fontWeight: "400!important",
    marginBottom: "0!important",
    fontSize: "1.25rem",
    textAlign: "left",
    lineHeight: 1.5,
  },
  heroSubheader: {
    color: themeColors.bsColors.MainBlue,
    fontWeight: "400!important",
    marginBottom: "0!important",
    fontSize: "1.1275rem",
    textAlign: "center",
    lineHeight: 1.5,
  },
  heroTitle: {
    color: themeColors.bsColors.MainBlue,
    fontWeight: "700!important",
    marginBottom: "0!important",
    fontSize: "0.875rem",
    textAlign: "left",
    lineHeight: 1,
  },
  typographyH3: {
    color: themeColors.bsColors.MainBlue,
    fontWeight: "700!important",
    marginBottom: "0!important",
    fontSize: "1.1275rem",
    textAlign: "left",
    lineHeight: 1.5,
  },
  typographyLineBreaks:{
    whiteSpace: "pre-wrap"
  },
  switchStyled: {
    switchBase: {
      color: themeColors.gray[400],
      '&$checked': {
          color: themeColors.bsColors.MainBlue,
      },
      '&$checked + $track': {
          backgroundColor: themeColors.bsColors.LogoLightBlue,
      },
    },
    checked: {},
    track: {},
  }
});

export default componentStyles;
